import { Component, Input, OnInit } from '@angular/core';
import { ActualiteModel } from '../../../models/ActualiteModel';
import { ActualiteApiService } from '../../../web-api-services/actualite.service';

@Component({
  selector: 'actualite-card',
  templateUrl: './actualite-card.component.html',
  styleUrls: ['./actualite-card.component.css'],
})
export class ActualiteCardComponent implements OnInit {
  @Input() badgeInfo: string = 'Dernière actualité';
  @Input() displayAucuneActualite: boolean = false;

  actualite: ActualiteModel = null;
  actualiteLoaded: boolean = false;

  constructor(private actualiteApiService: ActualiteApiService) {}

  ngOnInit() {
    this.loadActualite();
  }

  loadActualite() {
    this.actualiteApiService.getLastActualiteForUser(0).subscribe(actualite => {
      this.actualiteLoaded = true;
      this.actualite = actualite;
    });
  }
}
